import { requestResetPasswordApi } from "@/api/services/main/auth";
import { Button } from "@/components/elements/Button";
import { Form } from "@/components/elements/Form";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { recoverSchema } from "@/features/auth/schema/recoverSchema";
import { TRecoverForm } from "@/features/auth/types/recoverForm";
import { AppRoutes } from "@/routes/config";
import { setErrorForm, showError } from "@/utils/error";
import { getDynamicRoute } from "@/utils/url";
import { yupResolver } from "@hookform/resolvers/yup";
import { Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export const RecoverForm = () => {
  const navigate = useNavigate();
  const methods = useForm<TRecoverForm>({
    mode: "all",
    reValidateMode: "onBlur",
    resolver: yupResolver(recoverSchema),
  });
  const { control } = methods;

  const onSubmit = async (data: TRecoverForm) => {
    try {
      await requestResetPasswordApi(data);
      navigate(
        getDynamicRoute(AppRoutes.recoverComplete, {}, `email=${encodeURIComponent(data.email)}&companyCode=${encodeURIComponent(data.companyCode)}`),
      );
    } catch (error) {
      showError(error);
      setErrorForm(methods, error);
    }
  };

  return (
    <Form methods={methods} onSubmit={onSubmit} enableBlocker={false} schema={recoverSchema}>
      <Stack gap={3} width={400}>
        <FormField control={control} name="companyCode">
          <Input size="lg" />
        </FormField>
        <FormField control={control} name="email">
          <Input size="lg" />
        </FormField>
        <Button type="submit" variant="primary" fullWidth>
          メールを送信
        </Button>
      </Stack>
    </Form>
  );
};
